import type { BlueprintPage } from '../types';

/**
 * Stable per-sheet prefix for blueprintOverrides keys. Page numbers shift when
 * islands are added or removed, so scope by page type + island instead — that
 * pair is unique across every sheet getBlueprintPages emits.
 */
export const getPageOverrideScope = (page: BlueprintPage): string => {
	const { pageType, islandId } = page;
	return `${pageType}.${islandId ?? 'kitchen'}`;
};
